/* jshint esversion: 6, -W097 */
/* globals module */
'use strict';

/**
 * @module enervee_utils.callout_banner
 */
function bannerDirective() {
    return {
        restrict: 'E',
        replace: true,
        scope: {
            parentClass: '='
        },
        controllerAs: 'vm',
        controller: BannerController,
        template: require('./calloutBannerView.html')
    };
}

BannerController.$inject = ['$scope', '$window', 'CookiesService', 'UtilService'];
function BannerController ($scope, $window, CookiesService, UtilService) {

    var BANNER_OPENED_COOKIE_VALUE = "opened";

    var vm = this;

    var bannerSettings = UtilService.getSiteSetting('callout_banner_settings');

    if (bannerSettings) {
        vm.isOpen = bannerSettings.is_enabled;

        if (CookiesService.get(bannerSettings.code) === BANNER_OPENED_COOKIE_VALUE) {
            vm.isOpen = false;
        }
    } else {
        vm.isOpen = false;
    }

    if (vm.isOpen) {
        vm.title = bannerSettings.title;
        vm.link_text = bannerSettings.link_text;
        vm.css_class = bannerSettings.css_class;
        /*
         Possible css classes: accent, rebate, green, grey, alert, warning, success, info
         */

        $scope.parentClass = 'has-callout';
    }

    /**
     * Closes the banner and saves it in a cookie, so it will not be opened again for that banner
     */
    vm.close = function() {
        vm.isOpen = false;
        $scope.parentClass = '';
        markBannerAsOpened();
    };

    /**
     * Closes the banner and redirects the user to the banner's destination link
     */
    vm.redirect = function() {
        vm.close();
        $window.open(bannerSettings.link_url, '_blank');
    };

    /**
     * Creates a cookie which remembers the fact that the banner was closed
     */
    function markBannerAsOpened() {
        CookiesService.set(bannerSettings.code, BANNER_OPENED_COOKIE_VALUE);
    }

}

module.exports = bannerDirective;
